import React, { FC, useState } from "react";
import SumsubWebSdk from "@sumsub/websdk-react";

import { Message } from "../../common";
import { UIStatus } from "../../../types/GlobalTypes";

type Props = {
  token: string;
  email?: string;
  phone?: string;
  errors?: Error[];
  onStatusChanged?: (result: any) => void;
};

export const SumsubWebSdkWrapper: FC<Props> = ({
  token,
  email,
  phone,
  errors = [],
  onStatusChanged,
}) => {
  const [localErrors, setLocalErrors] = useState<Error[]>([]);

  return (
    <>
      {token && (
        <SumsubWebSdk
          accessToken={token || ""}
          expirationHandler={(expirationProps: any) => {
            console.log("expirationHandler", expirationProps);
          }}
          config={{
            email,
            phone,
            theme: "light",
          }}
          onMessage={(type: string, opts: any) => {
            switch (type) {
              case "idCheck.onApplicantStatusChanged":
              case "idCheck.onStepInitiated":
                onStatusChanged && onStatusChanged(opts);
                break;
            }
          }}
          onError={(error: Error) => setLocalErrors([error])}
        />
      )}

      {[...errors, ...localErrors].map((err: Error) => (
        <Message type={UIStatus.ERROR} text={err.message} key={err.name} />
      ))}
    </>
  );
};
